import { ExclamationCircleIcon } from '@heroicons/react/16/solid';

export const Profile = () => {
  return (
    <div>
      <div className="p-2 bg-yellow-200 rounded-lg flex items-center justify-center gap-2">
        <ExclamationCircleIcon
          className="
            w-5 h-5
            text-yellow-800
            inline-block
            align-middle
        "
        />
        <p>Page under construction</p>
      </div>
    </div>
  );
};
